import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getMeasuredUsingConfig = (prefix: string) => {
  const preparationBalance = wrap(`${prefix}.Preparation.Balance`);
  const preparationWashedCoarsePortionDryMassBalance = wrap(
    `${prefix}.Preparation.WashedCoarsePortion.MeasuredConstantDryMass.Equipment.DryMassBalance`
  );
  const preparationWashedFinePortionDryMassBalance = wrap(
    `${prefix}.Preparation.WashedFinePortion.MeasuredConstantDryMass.Equipment.DryMassBalance`
  );
  const measurementsBalance = wrap(`${prefix}.Measurements.Balance`);
  const measurementsWashedRecoveredRetainedAggregateDryMassBalance = wrap(
    `${prefix}.Measurements.WashedRecoveredRetainedAggregate.MeasuredConstantDryMass.Equipment.DryMassBalance`
  );
  const measurementsCoarsePortionRecoveredRetainedAggregateDryMassBalance = wrap(
    `${prefix}.Measurements.CoarsePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.Equipment.DryMassBalance`
  );
  const measurementsFinePortionRecoveredRetainedAggregateDryMassBalance = wrap(
    `${prefix}.Measurements.FinePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.Equipment.DryMassBalance`
  );

  return {
    [`${prefix}.Preparation.InitialSampleMass`]: preparationBalance,
    [`${prefix}.Preparation.WashedCoarsePortion.MeasuredConstantDryMass.DryingTray.ContainerMass`]: preparationBalance,
    [`${prefix}.Preparation.WashedCoarsePortion.MeasuredConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: preparationWashedCoarsePortionDryMassBalance,
    [`${prefix}.Preparation.WashedFinePortion.MeasuredConstantDryMass.DryingTray.ContainerMass`]: preparationBalance,
    [`${prefix}.Preparation.WashedFinePortion.MeasuredConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: preparationWashedFinePortionDryMassBalance,
    [`${prefix}.Preparation.RecommendedCoarsePortionMass`]: preparationBalance,
    [`${prefix}.Preparation.CoarsePortionMass`]: preparationBalance,
    [`${prefix}.Preparation.RecommendedFinePortionMass`]: preparationBalance,
    [`${prefix}.Preparation.FinePortionMass`]: preparationBalance,
    [`${prefix}.Preparation.TotalPortionMass`]: preparationBalance,

    [`${prefix}.Measurements.MassOfBalls`]: measurementsBalance,
    [`${prefix}.Measurements.WashedRecoveredRetainedAggregate.MeasuredConstantDryMass.DryingTray.ContainerMass`]: measurementsBalance,
    [`${prefix}.Measurements.WashedRecoveredRetainedAggregate.MeasuredConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: measurementsWashedRecoveredRetainedAggregateDryMassBalance,
    [`${prefix}.Measurements.CoarsePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.DryingTray.ContainerMass`]: measurementsBalance,
    [`${prefix}.Measurements.CoarsePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: measurementsCoarsePortionRecoveredRetainedAggregateDryMassBalance,
    [`${prefix}.Measurements.FinePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.DryingTray.ContainerMass`]: measurementsBalance,
    [`${prefix}.Measurements.FinePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: measurementsFinePortionRecoveredRetainedAggregateDryMassBalance,

    [`${prefix}.Measurements.ContainerMass_ExtraSieve`]: measurementsBalance,
    [`${prefix}.Measurements.ContainerAndRetainedMass_ExtraSieve`]: measurementsBalance,
  };
};

export default getMeasuredUsingConfig;
